import angular from 'angular';
import Logger from '../../../../shared/logger';

export function InsightService(RenderService, PrintService, DocumentService, DownloadService, $timeout, $compile) {
    const downloadPdfReport = ($scope, fileNameOptions) => {
        const fileName = getFileName(fileNameOptions);
        const fileType = 'application/pdf';

        return getRenderedReport($scope)
            .then(htmlElement => RenderService.renderToPdf({ htmlElement }))
            .then(pdfFile => DownloadService.downloadFile(pdfFile, { fileName, fileType }))
            .catch(error => Logger.error(error));
    };

    const printReport = $scope => PrintService.printAsync(getRenderedReport($scope));

    const getFileName = ({ positionName, companyName }) => {
        const talenyaPrefix = 'TALENYA';
        const insightReportLabel = 'Insight_Report';

        return `${talenyaPrefix} ${insightReportLabel} - ${positionName} - ${companyName}`;
    };

    const getRenderedReport = $scope => {
        const template = '<report-funnel-component></report-funnel-component>';

        return new Promise((resolve) => {
            const htmlElement = $compile(template)($scope)[0];

            $timeout(() => resolve(htmlElement), 2000);
        });
    };

    return {
        downloadPdfReport,
        printReport,
    };
}

angular.module('TALENYA-FE').factory('InsightService', InsightService);
